<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import StickyStatus from "@/components/menu/StickyStatus/StickyStatus.vue";
import StatusDot from "@/components/ui/StatusDot.vue";
import { isWorkitem } from "@/model/stickyType";
import { useWorkModeStore } from "@/store/workMode";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);

const isStickyStatusVisible = computed(
  () => !useWorkModeStore().isExecutionMode && isWorkitem(card),
);
</script>

<template>
  <ActionMenuDropdown
    v-if="isStickyStatusVisible"
    :action="cardActions.setStatus"
    :tooltip="card.status?.name"
  >
    <template #content>
      <StatusDot :status-class="card.status?.statusClass || 'undefined'" />
    </template>
    <StickyStatus />
  </ActionMenuDropdown>
</template>
